import { Box, useTheme } from "@mui/material";

export const LayoutFooter = () => {
  const currentYear = new Date().getFullYear();
  const version = import.meta.env.VITE_REACT_APP_VERSION;
  const theme = useTheme();
  const highlightColour = theme.palette.info.dark;

  return (
    <Box sx={{ display: 'flex', alignSelf: "end" }}>
      <Box sx={{ paddingRight: '20px' }}>
        Version:&nbsp;
        <span style={{ color: highlightColour }}>{version}</span>
      </Box>
      <Box>
        &copy; {currentYear}&nbsp;
        <span style={{ color: highlightColour }}>SIS</span>
      </Box>
    </Box>
  )
}
